import React, { lazy } from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
const testimonials = [{
  type: 'whatsapp',
  name: 'Javiera T.',
  time: '14:30',
  message: '¡Hola! Quería contarte que anoche fue la primera vez en meses que pudimos dormir de corrido. Mi perro no ladró ni una sola vez con los ruidos del pasillo. ¡Mil gracias! 🙏🐶',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&fm=webp&q=75',
  dogImg: 'https://images.unsplash.com/photo-1543466835-00a7907e9de1?w=300&h=200&fit=crop&fm=webp&q=75'
}, {
  type: 'text',
  name: 'Felipe R.',
  location: 'Viña del Mar',
  quote: 'Mis vecinos ya me habían amenazado con denunciarme por los ladridos. Desde que aplico los 7 minutos diarios, mi departamento es un templo de paz. El mejor dinero invertido.'
}, {
  type: 'instagram',
  name: '@camila_and_max',
  message: 'Literalmente me salvaste la vida y mis muebles jajaja. Max ya no destruye los cojines cuando me voy a trabajar. Es increíble cómo funciona la estimulación mental. ✨',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=56&h=56&fit=crop&fm=webp&q=75'
}, {
  type: 'text',
  name: 'Daniela P.',
  location: 'La Serena',
  quote: 'Pensé que mi perrita era hiperactiva y no tenía solución. Resulta que solo necesitaba usar su olfato. Ahora se queda dormida a mis pies mientras trabajo.'
}, {
  type: 'whatsapp',
  name: 'Matías C.',
  time: '09:15',
  message: 'Hermano, no te miento, esto es magia. Ayer dejé a mi perro solo por 4 horas y cuando volví estaba durmiendo en su cama. Antes me encontraba con un desastre. 10/10.',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&fm=webp&q=75'
}, {
  type: 'text',
  name: 'Sofía L.',
  location: 'Santiago Centro',
  quote: 'Vivir en un piso 15 con un perro ansioso era una pesadilla. El protocolo me enseñó a entenderlo y calmarlo sin regaños. Estamos mucho más conectados ahora.'
}];
export function TestimonialsSectionBottom() {
  return <section className="py-24 px-5 max-w-6xl mx-auto bg-zen-beige/30 rounded-[3rem] my-12 pt-[10px] pb-[10px] mt-[20px] mb-[20px]" data-id="element-294">
      <FadeInUp data-id="element-295">
        <div className="text-center mb-16" data-id="element-296">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-dark mb-6" data-id="element-297">
            Más Familias Felices
          </h2>
          <div className="flex items-center justify-center gap-2" data-id="element-298">
            <div className="flex text-yellow-400" data-id="element-299">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-current" data-id="element-300" />)}
            </div>
            <span className="font-bold text-slate-dark flex items-center gap-1" data-id="element-301">
              <CheckCircleIcon className="w-5 h-5 text-green-600" data-id="element-302" />
              Compra Segura Verificada
            </span>
          </div>
        </div>
      </FadeInUp>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-303">
        {testimonials.map((t, index) => <FadeInUp key={index} delay={index * 0.1} data-id="element-304">
            {t.type === 'whatsapp' ? <div className="bg-[#EFEAE2] p-4 rounded-3xl h-full flex flex-col shadow-sm border border-black/5" data-id="element-305">
                <div className="bg-[#075E54] text-white p-3 rounded-t-2xl flex items-center gap-3 -mt-4 -mx-4 mb-4" data-id="element-306">
                  <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" width={40} height={40} loading="lazy" decoding="async" data-id="element-307" />
                  <div data-id="element-308">
                    <p className="font-bold text-sm" data-id="element-309">{t.name}</p>
                    <p className="text-[10px] opacity-80" data-id="element-310">en línea</p>
                  </div>
                </div>
                <div className="bg-[#DCF8C6] p-3 rounded-2xl rounded-tl-none shadow-sm relative mb-2 self-start max-w-[90%]" data-id="element-311">
                  {t.dogImg && <img src={t.dogImg} alt="Perro feliz" className="w-full h-32 object-cover rounded-xl mb-2" width={300} height={128} loading="lazy" decoding="async" data-id="element-312" />}
                  <p className="text-slate-dark text-sm leading-relaxed" data-id="element-313">
                    {t.message}
                  </p>
                  <span className="text-[10px] text-slate-dark/50 absolute bottom-1 right-2" data-id="element-314">
                    {t.time}
                  </span>
                </div>
              </div> : t.type === 'instagram' ? <div className="bg-white p-6 rounded-3xl h-full flex flex-col shadow-sm border border-black/5" data-id="element-315">
                <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-100" data-id="element-316">
                  <div className="w-10 h-10 rounded-full p-[2px] bg-gradient-to-tr from-yellow-400 to-fuchsia-600" data-id="element-317">
                    <img src={t.avatar} alt={t.name} className="w-full h-full rounded-full object-cover border-2 border-white" width={56} height={56} loading="lazy" decoding="async" data-id="element-318" />
                  </div>
                  <p className="font-bold text-sm text-slate-dark" data-id="element-319">{t.name}</p>
                </div>
                <div className="bg-gray-100 p-4 rounded-2xl rounded-tl-none text-sm text-slate-dark leading-relaxed" data-id="element-320">
                  {t.message}
                </div>
              </div> : <div className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-md transition-shadow h-full flex flex-col border border-black/5" data-id="element-321">
                <div className="flex text-yellow-400 mb-4" data-id="element-322">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-323" />)}
                </div>
                <p className="text-slate-dark/80 italic mb-6 flex-grow text-base leading-relaxed" data-id="element-324">
                  "{t.quote}"
                </p>
                <div className="mt-auto pt-4 border-t border-zen-beige" data-id="element-325">
                  <p className="font-bold text-slate-dark text-sm" data-id="element-326">{t.name}</p>
                  <p className="text-xs text-slate-dark/60 mb-2" data-id="element-327">
                    {t.location}
                  </p>
                  <div className="flex items-center gap-1 text-[10px] font-medium text-slate-dark bg-pistachio/20 inline-flex px-2 py-0.5 rounded-full" data-id="element-328">
                    <CheckCircleIcon className="w-3 h-3 text-green-600" data-id="element-329" />
                    Verificado
                  </div>
                </div>
              </div>}
          </FadeInUp>)}
      </div>
    </section>;
}